module.exports = __webpack_public_path__ + "static/img/边2.7116307.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边2.png
// module id = ihkU
// module chunks = 2